<template>
    <df-admin-form :editing="isEditing" :loading="loading" @submit="submit" @cancel="$router.push({ name: 'admin-users' })">

        <div class="email-compose-fields">
            <image-upload
                ref="avatar"
                horizontal
                label="Avatar"
                :width="150"
                :height="150"
                :value="data.avatarBig"
                @input="v => data.avatar = v"
            />
            <text-field horizontal label="Vorname" v-model="data.firstname" :validation="$v.data.firstname"/>
            <text-field horizontal label="Nachname" v-model="data.lastname" :validation="$v.data.lastname"/>
            <text-field horizontal label="E-Mail Adresse" v-model="data.email" :validation="$v.data.email"/>
            <text-field horizontal label="Passwort" v-model="data.plainPassword" :validation="$v.data.plainPassword" v-if="!isEditing"/>
        </div>
        <div class="email-compose-fields">
            <image-upload
                ref="background"
                horizontal
                label="Header-Bild"
                :width="426"
                :height="121"
                :value="data.backgroundPath"
                @input="v => data.background = v"
            />
            <text-field horizontal label="Region" v-model="data.region" :validation="$v.data.region"/>
            <tag-list horizontal label="Spezialisierung" :options="specializationOptions" v-model="data.specialization" :validation="$v.data.specialization"/>
            <radio-checkbox multiple horizontal inline name="language" label="Sprachen" :options="languageOptions" v-model="data.languages" :validation="$v.data.languages"/>
        </div>
        <div class="email-compose-fields">
            <image-upload
                ref="logo"
                horizontal
                whitespace
                label="Logo"
                :width="155"
                :height="54"
                :value="data.companyLogoPath"
                @input="v => data.companyLogo = v"
            />
            <text-field horizontal label="Firma" v-model="data.company" :validation="$v.data.company"/>
            <text-field horizontal label="Strasse" v-model="data.companyStreet" :validation="$v.data.companyStreet"/>
            <text-field horizontal label="PLZ" v-model="data.companyPostcode" :validation="$v.data.companyPostcode"/>
            <text-field horizontal label="Ort" v-model="data.companyLocation" :validation="$v.data.companyLocation"/>
            <select-menu horizontal label="Land" :options="countries" v-model="data.companyCountry" :validation="$v.data.companyCountry"/>
            <text-field horizontal label="Telefon" v-model="data.companyPhone" :validation="$v.data.companyPhone"/>
            <text-field horizontal label="Website" v-model="data.companyWebsite" :validation="$v.data.companyWebsite"/>
        </div>

    </df-admin-form>
</template>

<script>
    import adminForm from '../../../../mixins/adminForm';
    import userForm from '../../../../mixins/user-form';
    import User from '../../../../models/User';

    export default {
        mixins: [adminForm, userForm],

        data: () => ({
            model: User,
            defaults: { languages: ['de'] },
        }),

        methods: {
            async preSave() {
                await Promise.all([
                    this.$refs.avatar.upload(),
                    this.$refs.background.upload(),
                    this.$refs.logo.upload(),
                ]);
            },

            async submit() {
                if (await this.saveForm()) {
                    this.$router.push({ name: 'admin-users' });
                }
            },
        },
    };
</script>
